(function () {
    'use strict';

    angular
        .module('app')
        .factory('libraryFactory', factory);

    factory.$inject = ['$http', '$q'];

    function factory($http, $q) {
        var service = {
            getTree: getTree
        };

        return service;

        function getTree() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/Library/GetLibraryTree').then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }
    }
})();